export default __webpack_public_path__ + "static/media/loc_img_3.d6ddb1d7.jpg";